import authenticate from '@/middleware/authenticate'

export default [
  {
    path: '/pay-item-deductions',
    name: 'pay-item-deduction',
    meta: { middleware: authenticate },
    component: () => import('@/pages/hr/pay-item-deduction')
  }
]
